import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

export interface AppContainerWithMenuState {
  isAutoExpanded: boolean;
  isFullMenuVisible: boolean;
  isDashboardMenuVisible: boolean;
}

const initialState: () => AppContainerWithMenuState = () => {
  const isAutoExpanded = appStorage.getAppMenuIsAutoExpanded();
  const isFullMenuVisible = appStorage.getAppMenuIsFullMenuVisible();
  const isDashboardMenuVisible = appStorage.getAppMenuIsDashboardMenuVisible();

  // undefined is the same as true
  if (isAutoExpanded !== false || isFullMenuVisible || isDashboardMenuVisible) {
    appStorage.setAppMenuIsAutoExpanded(true);

    return {
      isAutoExpanded: true,
      isFullMenuVisible: isFullMenuVisible ?? false,
      isDashboardMenuVisible: isDashboardMenuVisible ?? false,
    };
  }

  return {
    isAutoExpanded,
    isFullMenuVisible: isFullMenuVisible ?? false,
    isDashboardMenuVisible: isDashboardMenuVisible ?? false,
  };
};

export const appContainerWithMenuSlice = createSlice({
  name: 'appContainerWithMenu',
  initialState,
  reducers: {
    setIsAutoExpandedAction(state, action: PayloadAction<boolean>) {
      state.isAutoExpanded = action.payload;
    },
    setIsFullMenuVisibleAction(state, action: PayloadAction<boolean>) {
      state.isFullMenuVisible = action.payload;
    },
    toggleIsFullMenuVisibleAction(state) {
      state.isFullMenuVisible = !state.isFullMenuVisible;
    },
    setIsDashboardMenuVisibleAction(state, action: PayloadAction<boolean>) {
      state.isDashboardMenuVisible = action.payload;
    },
    showDashboardMenuAction(state) {
      state.isDashboardMenuVisible = true;
      state.isFullMenuVisible = false;
    },
    hideDashboardMenuAction(state) {
      if (state.isDashboardMenuVisible) {
        state.isDashboardMenuVisible = false;
        state.isFullMenuVisible = true;
      }
    },
    clearAppContainerStateAction() {
      return initialState();
    },
  },
});

export const {
  setIsAutoExpandedAction,
  setIsFullMenuVisibleAction,
  toggleIsFullMenuVisibleAction,
  setIsDashboardMenuVisibleAction,
  showDashboardMenuAction,
  hideDashboardMenuAction,
  clearAppContainerStateAction,
} = appContainerWithMenuSlice.actions;
